import React, {Fragment} from "react";

import {Trans, useTranslation} from "react-i18next";
import {NavLink, useNavigate, useParams} from "react-router-dom";

import {TitleH2, TitleH4} from "components/generic";
import {CardBlogDiv, PostBlogSection, BlogPostDiv, BlogBackDiv, PostTitle} from "./styles";
import {BLOG_ROUTE} from "utils/constants";
import {ISeo} from "interfaces/intarfaces";
import {ItemLink} from "pages/rootpage/styles";
import {HeaderSEO} from "components/headerSEO";
import {IconBack} from "../../../../components/Icons/Back";
import { ContentDiv } from "components/containers";

export const CardBlog: React.FC<{ keyPost: string }> = ({ keyPost }) => {
  const { t, i18n } = useTranslation(`blog/${keyPost}`);
  const navigate = useNavigate();

  let allowedLang = t("lang", { returnObjects: true });
  if (!!allowedLang.length) {
    if (!allowedLang.includes(i18n.language === "gb" ? "gb" : i18n.language))
      return null;
  }

  return (
      <CardBlogDiv
        onClick={() =>
          navigate(`/${i18n.language}${BLOG_ROUTE.slice(5)}/${keyPost}`)
        }
      >
        <img
          src={(process.env.PUBLIC_URL as string) + "/images/" + t("images.0")}
          alt="illustration"
        />
        <span>{t("title")}</span>
        <p>{t("shotInfo")}</p>
      </CardBlogDiv>
  );
};

export const PostBlog: React.FC = () => {
  const { id } = useParams();
  const { t: t_main, i18n } = useTranslation('blog');
  const { t } = useTranslation(`blog/${id}`);

  const images: string[] = t("images", { returnObjects: true });
  const labels: string[] = t("label", { returnObjects: true });
  const links: React.ReactNode[] = (
    t("links", { returnObjects: true }) as string[]
  ).map((item) => (
    <ItemLink
      href={item!}
      target="_blank"
      style={{ fontSize: "20px", textDecoration: "underline" }}
    />
  ));
  const orderImg: number[] = (
    t("order", { returnObjects: true }) as string[]
  ).map((item) => Number(item));
  const textLines: string[] = t("text", { returnObjects: true });
  const seo = t("seo", { returnObjects: true }) as ISeo;

  return (
    <ContentDiv>
      {seo && <HeaderSEO {...seo} />}
      <PostBlogSection>
        <BlogBackDiv>
          <NavLink to={`/${i18n.language}${BLOG_ROUTE.slice(5)}`}>
            {IconBack}{t_main("blog.backToAll")}
          </NavLink>
        </BlogBackDiv>
        <PostTitle>{t("title")}</PostTitle>
        {textLines.length &&
          textLines.map((item, num) => (
            <Fragment key={num}>
              {orderImg.includes(num) && (
                <div>
                  <img
                    src={
                      (process.env.PUBLIC_URL as string) +
                      "/images/" +
                      images.shift()
                    }
                    alt="This illustration"
                  />
                  <TitleH4>{labels.shift()}</TitleH4>
                </div>
              )}
              <Trans
                t={t}
                i18nKey={"text." + num}
                parent="p"
                components={links as any}
              />
            </Fragment>
          ))}
      </PostBlogSection>
    </ContentDiv>
  );
};
